import { useEffect } from 'react';
import { useLiveChatContext } from '../LiveChatContext';
import { LcEventSchema } from '../liveChatMachine';

const events = {
  send: 'lc-service-send',
};

// use as an interface where livechat service / context is not available
export const useLiveChatService = () => {
  return {
    send(detail: LcEventSchema) {
      const e = new CustomEvent(events.send, { detail });
      document.dispatchEvent(e);
    },
  };
};

// should be used once where livechat service is available
export const useLiveChatServiceObserver = (
  ...params: Parameters<typeof useLiveChatContext>
) => {
  const [machine, lcService] = params;

  const onSend = (e: CustomEvent<LcEventSchema>) => {
    lcService?.send?.(e?.detail);
  };

  useEffect(() => {
    document.addEventListener(events.send, onSend);

    return () => {
      document.removeEventListener(events.send, onSend);
    };
  }, []);
};
